export default __webpack_public_path__ + "static/media/GLOFront.b8761df9.png";